import { ChartLineUpIcon as PhosphorChartLineUpIcon } from "@phosphor-icons/react/dist/ssr/ChartLineUp";

import { createAppIcon } from "@/components/createAppIcon";

export const InsightsIcon = /* @__PURE__ */ createAppIcon(PhosphorChartLineUpIcon);
